/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Translations { 
    uiscreenid?: number;
    contenttype?: string;
    tablename?: string;
    fieldname?: string;
    fieldvalue?: string;
    uilanguageid?: number;
    displayname?: string;
    sort?: number;
    reftranslation?: string;
    tobetranslated?: boolean;
}

